/*
CONTENT TYPE IDS:
  { label: 'Calendar', id: '0196655b-f6a4-3874-bc21-801b8c9fdd1a' },
  { label: 'Lesson Submission Form', id: '0824ad91-cab4-3a09-9049-ebb2ae2c8234' },
  { label: 'Language Video', id: '147d1a55-f7b7-3034-9029-658d47382c8f' },
  { label: 'Sponsor', id: '17a02494-6f58-3717-bcd6-08f9031b71a7' },
  { label: 'Internal Answer Article', id: '27953b45-fa31-3be6-9962-84da2f118e56' },
  { label: 'Standard Operating Procedure', id: '31af2ad9-b559-3383-9ea5-5886e73fffd2' },
  { label: 'Genealogy Reveal', id: '3b508fbf-d551-3c54-b3a5-bca56a908bc1' },
  { label: 'Video', id: '431a5800-2fb3-3b19-9801-23dc4b0ff9a8' },
  { label: 'Tips And Tricks', id: '486f38ff-4ffd-3d5f-b23a-4e42218ee944' },
  { label: 'Series', id: '4954f3b1-d436-38d4-92bb-5d0ca7dfb3e5' },
  { label: 'Image', id: '4da1a812-2b2b-36a7-a321-fea9c9594cb9' },
  { label: 'Blog', id: '4dc607ae-1875-3c36-ae5f-a82a037b9743' },
  { label: 'Article', id: '4f8e492c-6f2f-390e-bc61-f176d3a37ab9' },
  { label: 'Blog Post', id: '5be10472-b2e0-37b5-b6f8-8f381832e94f' },
  { label: 'Recipe', id: '6dc3b561-9345-34ab-a20d-e46453f016b9' },
  { label: 'Fashion Show', id: '6fa856ac-863a-300c-8cde-c81ee4bca3a5' },
  { label: 'Class/Session', id: '7276cabb-407f-3b74-b0dd-5de9361cbc81' },
  { label: 'Traditions And Holidays', id: '728bb629-7f2f-3629-b364-4ae3d09228aa' },
  { label: 'Lesson', id: '74f70d4b-17f7-3d22-a494-089a682221ee' },
  { label: 'Location', id: '7e9611fd-a3e4-3e55-89ad-82c98f2cec07' },
  { label: 'Author', id: '7f0435e9-b5f5-3286-9fe0-e839ddd16058' },
  { label: 'Pitch Submission Form', id: '84e5a402-e119-366a-99c7-f614acfb1bc1' },
  { label: 'Tag', id: '90602a54-e7fb-3b69-8e25-236e50f8f7f5' },
  { label: 'Speakers', id: '93adf2ed-4ee5-3090-92f5-a36a8a949dd2' },
  { label: 'Event', id: '970cdfb7-4bb8-38a1-9fdb-f46e7f373c64' },
  { label: 'Music Competition', id: '99b78177-b665-3932-aa59-9adfc13b6718' },
  { label: 'Host Broadcast', id: 'a78841c5-f064-347d-a611-f2a2f6116faf' },
  { label: 'Live Session', id: 'a7b6abc1-4b21-368c-9916-d1793abc0918' },
  { label: 'Homeland Fact', id: 'aafa9b53-5e55-3e7c-be8b-58f7f70a318d' },
  { label: 'Your Hometown', id: 'b8bf0c28-5692-390b-9d36-2cdf01e7d018' },
  { label: 'Section', id: 'ba7d9749-a9b7-3050-86ad-15e1b9f4be7d' },
  { label: 'Keynote Speaker', id: 'bcbcf774-5699-385b-8802-8c057c37b34c' },
  { label: 'Temple Policy Article', id: 'c8cbfe3c-f1c8-3fa5-aa04-2c3c6a937870' },
  { label: 'Virtual Tour', id: 'd14d41b6-4525-372d-a3e8-9feee2ecf222' },
  { label: 'Lesson Series', id: 'd316b83e-29f3-35cf-9b73-7b4ed9ee2e75' },
  { label: 'Page', id: 'e30edf29-8fe1-3857-864d-a0240c664e80' },
  { label: 'Exhibitor', id: 'e3b470da-fdf3-3f89-9eca-f29e304cacd1' },
  { label: 'Creator', id: 'f1294ca7-6946-3a0f-9129-4f35378c0c30' },
  { label: 'External Answer Article', id: 'fee619d6-1ab0-3f4a-a193-5906cf5594f3' },
*/

/**
 * Get query results from brightspot
 *
 */

import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

const SEARCH_PAGE_ID = '/dosearch'
const sessionsAndSeriesTypes =
  ', types: ["d14d41b6-4525-372d-a3e8-9feee2ecf222","b8bf0c28-5692-390b-9d36-2cdf01e7d018","728bb629-7f2f-3629-b364-4ae3d09228aa","6fa856ac-863a-300c-8cde-c81ee4bca3a5","147d1a55-f7b7-3034-9029-658d47382c8f","3b508fbf-d551-3c54-b3a5-bca56a908bc1","486f38ff-4ffd-3d5f-b23a-4e42218ee944","6dc3b561-9345-34ab-a20d-e46453f016b9","7276cabb-407f-3b74-b0dd-5de9361cbc81", "4954f3b1-d436-38d4-92bb-5d0ca7dfb3e5", "a7b6abc1-4b21-368c-9916-d1793abc0918"]'

export const sessionSearchGQLQuery = ({ query, category }) => {
  const categorySearch = category ? `, categories: "${category}"` : ''
  const querySearch = query ? `, query: ${JSON.stringify(query)}` : ''
  const imageSize = getIsLowBandwidth() ? 250 : 500

  return gql(`
      query Pagination ($page: Int = 1) {
        RootsTechSearchPage(id: "${SEARCH_PAGE_ID}", page: $page, ${sessionsAndSeriesTypes} ${querySearch} ${categorySearch}) {
          nextPage
          results {
            date{
              timestamp
            }
            duration
            membersOnly
            objectTypeId
            locale
            parentLocale
            url
            type
            title
            contentUUID
            image {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                }
              }
            }
            creators {
              name
              profilePhoto {
                custom(height: ${imageSize}, width: ${imageSize}) {
                  image {
                    src
                  }
                }
              }
            }
          }
        }
      }
    `)
}

// ensures the value is stringified as an array, even if just one item
const stringifyAsArray = (item) => {
  if (Array.isArray(item)) {
    return JSON.stringify(item)
  }
  return `[${JSON.stringify(item)}]`
}

export const deepLinkGQLQuery = ({ urlParams }) => {
  const querySearch = urlParams?.text ? `, query: ${JSON.stringify(urlParams.text)}` : ''
  let languageSearch = ''

  if (urlParams?.language && !urlParams?.broadSearch) {
    languageSearch = `, parentLanguages: ${JSON.stringify(urlParams.language)}, exclusiveCountryCategory: true`
  } else if (urlParams?.language) {
    languageSearch = `, languages: ${JSON.stringify(urlParams.language)}`
  }

  const countrySearch = urlParams?.country ? `, countries: ${stringifyAsArray(urlParams.country)}` : ''
  const categorySearch = urlParams?.category ? `, categories: ${JSON.stringify(urlParams.category)}` : ''
  const imageSize = getIsLowBandwidth() ? 250 : 500

  return gql(`
      query Pagination ($page: Int = 1) {
        RootsTechSearchPage(id: "${SEARCH_PAGE_ID}", page: $page, ${sessionsAndSeriesTypes} ${languageSearch} ${countrySearch} ${querySearch} ${categorySearch}) {
          nextPage
          languageOptions {
            label
            value
          }
          countryOptions {
            label
            value
          }
          results {
            date{
              timestamp
            }
            duration
            membersOnly
            objectTypeId
            locale
            parentLocale
            url
            type
            title
            contentUUID
            image {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                }
              }
            }
            creators {
              name
              profilePhoto {
                custom(height: ${imageSize}, width: ${imageSize}) {
                  image {
                    src
                  }
                }
              }
            }
          }
        }
      }
    `)
}

export const exhibitorSearchGQLQuery = ({ query }) => {
  const imageSize = getIsLowBandwidth() ? 250 : 500

  return gql(`query Pagination ($page: Int = 1) {
      RootsTechSearchPage(id: "${SEARCH_PAGE_ID}", page: $page, types: ["e3b470da-fdf3-3f89-9eca-f29e304cacd1"], query: ${JSON.stringify(
    query
  )} ) {
        nextPage
        results {
          url
          title
          contentUUID
          image {
            custom(height: ${imageSize}, width: ${imageSize}) {
              image {
                src
              }
            }
          }
        }
      }
    }
  `)
}

export const initCategoryFiltersGQL = () => {
  return gql(`
    {
      RootsTechSearchPage(id: "${SEARCH_PAGE_ID}") {
        categoryOptions {
          contentUUID
          title
          image {
            image {
              src
            }
          }
        }
      }
    }
  `)
}

export const getContentLocales = () => {
  return gql(`
    {
      RootsTechSearchPage(id: "${SEARCH_PAGE_ID}"${sessionsAndSeriesTypes}) {
        languageOptions {
          label
          value
        }
      }
    }
  `)
}

export const getContentRegions = () => {
  return gql(`
    {
      RootsTechSearchPage(id: "${SEARCH_PAGE_ID}"${sessionsAndSeriesTypes}) {
        countryOptions {
          label
          value
        }
      }
    }
  `)
}
